import React from "react"
import PropTypes from "prop-types"

class ImageUpload extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      uri: this.props.uri,
      imageLinkURL: this.props.imageLinkURL,
      description: this.props.description,
      uploadSuccess: false,
      fileName: this.props.fileName,
      objectName: "",
      formError: null,
      fileError: null,
      fileSelected: null,
    }

    this.fileInput = React.createRef()

    this.file = null
  }

  uploadFile = async () => {
    if (this.state.fileError) {
      return
    }

    let data = new FormData()

    data.append("name", this.state.fileName)
    data.append("created_by", this.props.createdBy)
    data.append("file", this.file)

    try {
      let response = await fetch("/upload/image", {
        method: "POST",
        body: data,
      })

      let json = await response.json()

      if (json.success) {
        this.setState({
          uploadSuccess: true,
          formError: null,
          uri: URI_BASE + json.success.key,
        })
      } else if (json.error.type === "WRONG_MIME_TYPE") {
        this.setState({
          fileError: json.error.message,
        })
      } else {
        this.setState({
          formError: json.error.message,
        })
      }
    } catch (err) {
      console.log(err)
    }
  }

  getValue = () => {
    return {
      type: "image-upload-component",
      props: {
        uri: this.state.uri,
        description: this.state.description,
        fileName: this.state.fileName,
        imageLinkURL: this.state.imageLinkURL.trim(),
      },
    }
  }

  validate = () => {
    if (this.state.fileError || this.state.formError) {
      return false
    }

    if (this.state.fileName < this.props.requiredLength) {
      return false
    }

    return true
  }

  fileInputChange = async (e) => {
    this.file = e.target.files[0]

    let { x, y } = this.props.dimensions || {}

    if (this.file) {
      this.setState({
        uploadSuccess: false,
        fileName: "",
      })

      let image = new Image()

      image.onload = () => {
        if (x && y && (!(image.height === y) || !(image.width === x))) {
          this.setState(
            {
              fileError: `Image dimensions must be ${x}x${y}.`,
              fileSelected: null,
            },
            () => {
              this.file = null
            }
          )
        } else {
          this.setState({
            fileSelected: this.file.name,
            fileError: null,
          })
        }
      }

      image.src = URL.createObjectURL(this.file)
    }
  }

  handleFileNameChange = (e) => {
    this.setState({
      fileName: e.target.value,
      fileError: null,
    })
  }

  handleImageLinkChange = (e) => {
    this.setState({
      imageLinkURL: e.target.value,
    })
  }

  handleDescriptionChange = (e) => {
    this.setState({
      description: e.target.value,
    })
  }

  renderImage = () => {
    if (this.state.uploadSuccess || this.props.uri) {
      return (
        <div>
          <img src={this.state.uri} />
        </div>
      )
    }
  }

  renderFormError = () => {
    if (this.state.formError) {
      return "form-control is-invalid"
    }

    return "form-control"
  }

  renderFileUpload = () => {
    let { imageLink } = this.props
    let isSubmitDisabled =
      !(this.state.fileName.length >= this.props.requiredLength) ||
      this.state.fileError ||
      !this.file ||
      this.state.uploadSuccess
    let isTextDisabled = !this.state.fileSelected || this.state.uploadSuccess
    let errorVisibility = this.state.fileError ? { display: "block" } : null
    let labelText = this.state.fileSelected || this.props.text

    return (
      <div>
        <div className="input-group mb-3">
          <div className="custom-file">
            <input
              type="file"
              className="form-control"
              id={this.props.id}
              ref={this.fileInput}
              onChange={this.fileInputChange}
              accept={this.props.accept}
            />
            <label className="custom-file-label" htmlFor={this.props.id}>
              {labelText}
            </label>
          </div>
          <div className="invalid-feedback" style={errorVisibility}>
            {this.state.fileError}
          </div>
        </div>
        <div className="input-group mb-3">
          <input
            disabled={isTextDisabled}
            type="text"
            className={this.renderFormError()}
            placeholder={this.props.placeholder}
            value={this.state.fileName}
            onChange={this.handleFileNameChange}
          />
          <div className="invalid-feedback">{this.state.formError}</div>
        </div>
        <div className="input-group mb-3">
          <input
            disabled={isTextDisabled}
            type="text"
            name="description"
            className="form-control"
            placeholder="Image Description & Credit"
            value={this.state.description}
            onChange={this.handleDescriptionChange}
          />
        </div>
        {imageLink && (
          <div className="input-group mb-3">
            <input
              disabled={isTextDisabled}
              type="text"
              name="URL"
              className="form-control"
              placeholder="Image Link URL"
              value={this.state.imageLinkURL}
              onChange={this.handleImageLinkChange}
            />
            <small id="delayhelp" className="form-text text-muted">
              Setting image link URL will disable the image modal.
            </small>
          </div>
        )}
        <div className="input-group mb-3">
          <button
            disabled={isSubmitDisabled}
            onClick={this.uploadFile}
            className="btn btn-outline-secondary"
            type="button"
          >
            Upload
          </button>
        </div>
      </div>
    )
  }

  render() {
    return (
      <div className="image-upload">
        {this.renderFileUpload()}
        {this.renderImage()}
      </div>
    )
  }
}

const URI_BASE = process.env.S3BUCKET + "/uploads/images/"

ImageUpload.defaultProps = {
  uri: "",
  description: "",
  text: "Upload Image",
  fileName: "",
  id: "1",
  createdBy: "etr",
  dimensions: null,
  requiredLength: 3,
  placeholder: "Image Name",
  accept: "image/*,.jpg,.jpeg,.png",
  imageLinkURL: "",
  imageLink: true,
}

ImageUpload.propTypes = {
  text: PropTypes.string,
  fileName: PropTypes.string,
  id: PropTypes.string,
  createdBy: PropTypes.string,
  dimensions: PropTypes.shape({
    x: PropTypes.number,
    y: PropTypes.number,
  }),
  requiredLength: PropTypes.number,
  placeholder: PropTypes.string,
  accept: PropTypes.string,
  imageLink: PropTypes.bool,
}

export default ImageUpload
